var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useCallback, useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import Dialog from "../../base/ui/components/web/Dialog";
// import $ from 'jquery';
//@ts-ignore
import JitiStreamBackgroundEffect from "../../stream-effects/virtual-background";
import { translate } from "../../base/i18n/functions";
import FaceRegistrationPreview from "./FaceRegistrationPreview";
//Apply styles of Dialog and video box using makeStyles
const useStyles = makeStyles()((theme) => {
    return {
        dialogContainer: {
            width: "626px",
        },
    };
});
function FaceRegistration({ initialOptions, t }) {
    const { classes } = useStyles();
    const [options, setOptions] = useState(Object.assign({}, initialOptions));
    const [previewIsLoaded, setPreviewIsLoaded] = useState(false);
    //Creating new instance of FaceRecognitionEffect to use its functions
    const faceRecognition = new JitiStreamBackgroundEffect();
    //Button click handler - capture face image when apply button is clicked
    const onSub = () => {
        faceRecognition._onCaptureFaceImg();
    };
    const loadedPreviewState = useCallback((loaded) => __awaiter(this, void 0, void 0, function* () {
        setPreviewIsLoaded(loaded);
    }), []);
    // Hook to make the faceMesh applied automatically
    useEffect(() => {
        setOptions({
            enabled: true,
        });
    }, [options]);
    const disableCapture = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        setOptions({
            enabled: false,
        });
    }), []);
    return (React.createElement(Dialog, { onSubmit: onSub, onCancel: disableCapture, ok: {
            disabled: !options || !previewIsLoaded,
            translationKey: t("virtualBackground.apply"),
        }, size: "large", titleKey: "toolbar.faceRegistration" },
        React.createElement(FaceRegistrationPreview, { loadedPreview: loadedPreviewState, options: options })));
}
export default translate(FaceRegistration);
